import { render, staticRenderFns } from "./SvgIcon.vue?vue&type=template&id=3c44f174&scoped=true"
import script from "./SvgIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./SvgIcon.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./SvgIcon.vue?vue&type=style&index=0&id=3c44f174&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c44f174",
  null
  
)

export default component.exports